import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class JointlyService {
  apiUsers ="";

  constructor(
      private http: HttpClient,
  ) {
    this.apiUsers = environment.apiUser;
  }

  getJointlyContracts() : Observable<any>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.get<any>(`${this.apiUsers}/jointly/contracts`, {headers});
  }

}
